export const CONSTANTS = {
  globalInfoKeyMap: {
    regionServerSupported: "regionServerSupported",
  },
  cacheKeyMap: {
    supportMigrate: "__maxSupportMigrate",
    migrateConfig: "__maxMigrateConfig",
    tenantCode: "__maxTenantCode",
  },
  storageKeyMap: {
    storeInfo: "__maxStoreInfo",
    permCodes: "__maxPermCodes",
    userInfo: "__maxUserInfo",
    roles: "_roles",
    deviceListKey: "__iotdeviceList"
  },
  migrateModeMap: {
    offline: "offline",
    online: "online",
  },
  buildCodeKey: "max-model-buildcode",
}
